<app-modal-window 
  *ngIf="!(mobileDetector.isMobile | async)" 
  [title]="title" 
  [showModal]="showModal"
  [fullscreen]="fullscreen"
  [hasBackdrop]="hasBackdrop"
  [hideHeader]="hideHeader"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</app-modal-window>

<app-bottom-drawer 
  *ngIf="mobileDetector.isMobile | async" 
  [title]="title" 
  [showDrawer]="showModal"
  [fullscreen]="fullscreen"
  [hasBackdrop]="hasBackdrop"
  [hideHeader]="hideHeader"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</app-bottom-drawer>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>